import React from "react";
import { FormControlLabel, Switch } from "@mui/material";

interface SwitchProps {
  name: string;
  defaultValue?: boolean;
  label?: string;
  checked?: boolean;
}

const AppSwitch: React.FC<SwitchProps> = ({
  name,
  defaultValue,
  label,
  checked,
}) => {
  return (
    <FormControlLabel
      name={name}
      className="mb-24"
      checked={checked}
      control={<Switch defaultChecked={defaultValue} />}
      label={label}
    />
  );
};

export default AppSwitch;
